// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import XngZone from "@steiner/App/Components/Common/XngZone";
import { DivWrapper } from "@steiner/XDL/constants";
import React, { FC } from "react";
import { css } from "styled-components";

export interface OwnProps extends WidgetProps {}

export interface BrandDetailsPageLayout {
    container?: InjectableCss;
}

export const brandDetailsPageLayout: BrandDetailsPageLayout = {
    container: {
        css: css`
            display: flex;
            flex-direction: column;
            row-gap: 48px;
            & > ${DivWrapper}:empty {
                display: none;
            }
        `,
    },
};

const styles = brandDetailsPageLayout;
const BrandDetailsPageLayout: FC<OwnProps> = ({ id }) => {
    return (
        <StyledWrapper {...styles.container} data-test-selector="Brand-Details-Page-Layout">
            <XngZone contentId={id} zoneName="Content01" hint="Zone For Logo"></XngZone>

            <XngZone contentId={id} zoneName="Content02" hint="Zone For Featured Image And Brand Content"></XngZone>

            <XngZone contentId={id} zoneName="Content03" hint="Zone For Links"></XngZone>

            <XngZone contentId={id} zoneName="Content04" hint="Zone For Categories"></XngZone>

            <XngZone contentId={id} zoneName="Content05" hint="Zone For ProductLines"></XngZone>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: BrandDetailsPageLayout,
    definition: {
        group: "Layout" as any,
        displayName: "Brand Details Layout",
        allowedContexts: ["BrandDetailsPage"],
    },
};

export default widgetModule;
